// Layout.js
import React from 'react';
import Header from './Header';
import Footer from './Footer';
import './Layout.css'; 

const Layout = ({ children, onLoginClick }) => (
  <div className="layout-container">
    <Header onLoginClick={onLoginClick} />
    <main>{children}</main>
    <Footer />
  </div>
);

export default Layout;
